import { storeAuth, StoreAuthActionPayload, storeExpired, storeForbidden, storeLogout } from '@/model/auth/actions';
import { createReducerTypeSafe } from '@/utils/redux';

import { initialState, State } from './types';

export const reducers = createReducerTypeSafe<State>(initialState, [
  [
    storeAuth,
    (state: State, payload: StoreAuthActionPayload): State => ({
      ...state,
      ...payload,
      initialized: true,
    }),
  ],
  [
    storeExpired,
    (state: State, payload: boolean): State => ({
      ...state,
      expired: payload,
    }),
  ],
  [
    storeForbidden,
    (state: State, payload: boolean): State => ({
      ...state,
      forbidden: payload,
    }),
  ],
  [
    storeLogout,
    (): State => ({
      initialized: true,
      loggedOut: true,
      expired: false,
      isNewUser: false,
      forbidden: false,
      success: false,
    }),
  ],
]);

export default reducers;
